import { isObject, isNotNil } from 'core/service/lib/type-check'

import RiderBenefitSummary from './rider-benefit-summary'
import RiderWithBenefitModal from './rider-benefit-modal'
import { formatNumber } from 'core/service/lib/number-format'
import MESSAGES from 'core/data-model/constants/bi-messages'
import { AgentProtectionDisclaimer } from './agent-protection-disclaimer'
import { AdditionalDisclaimer } from './additional-disclaimer'

const renderMEBRiderBenefitsRow = (rowNumber, mebRiderBenefitsRowProps) => {
  const benefitDescription = mebRiderBenefitsRowProps.description
    .split('\n')
    .map((text) => <div key={`${text}-${rowNumber}`}>{text}</div>)
  const benefitValue = isNaN(parseInt(mebRiderBenefitsRowProps.value))
    ? mebRiderBenefitsRowProps.value
    : formatNumber(parseInt(mebRiderBenefitsRowProps.value))

  return (
    <tr key={`meb-rider-benefit-row-${rowNumber}`} id={`meb-rider-benefit-row-${rowNumber}`}>
      <td>
        <ol start={`${rowNumber}`}>
          <li> {benefitDescription}</li>
        </ol>
      </td>
      <td>{benefitValue}</td>
    </tr>
  )
}

const renderMEBRiderBenefitsTable = (benefits) => {
  return (
    <div className="details-table">
      <table id="meb-benefit-table">
        <thead>
          <tr>
            <td>{MESSAGES.BENEFIT_LIST}</td>
            <td>ผลประโยชน์ต่อวัน (บาท)</td>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>{MESSAGES.DISCLAIMER_MAX_HOSPITAL_BENEFIT}</td>
            <td></td>
          </tr>
          {benefits.map((benefit, index) => {
            return renderMEBRiderBenefitsRow(index + 1, {
              description: isObject(benefit) && isNotNil(benefit.description) ? benefit.description : '',
              value: isObject(benefit) && isNotNil(benefit.value) ? benefit.value : '',
            })
          })}
        </tbody>
      </table>
    </div>
  )
}

const MEBRiderBenefit = ({ rider, benefits }) => {
  const title = `${rider.description} ${rider.name}`
  const benefitTable = benefits ? renderMEBRiderBenefitsTable(benefits) : null
  return (
    <RiderWithBenefitModal
      id="meb-rider-benefit"
      className="rider meb-rider"
      title={title}
      modalChildren={benefitTable}
    >
      <RiderBenefitSummary rider={rider} />
      {benefitTable}
      <AgentProtectionDisclaimer rider={rider} />
      <AdditionalDisclaimer rider={rider} />
    </RiderWithBenefitModal>
  )
}

export default MEBRiderBenefit
